<h1 class="mat-title">
  <span>{{ text }}</span
  >{{ text }}
</h1>
